








































import { PropType } from 'vue';
import TableContainer from '../../../shared/libs/table/components/TableContainer.vue';
import TableHeading from '../../../shared/libs/table/components/TableHeading.vue';
import TableRow from '../../../shared/libs/table/components/TableRow.vue';
import TableBody from '../../../shared/libs/table/components/TableBody.vue';
import TableHead from '../../../shared/libs/table/components/TableHead.vue';
import { SecureDocumentModel } from '../../../shared/models/secureDocument.model';
import DocumentPreviewTableRow from './DocumentPreviewTableRow.vue';
import { DocumentWithChildrenModel } from '../../../shared/models/documentWithChildren.model';
import Icon from '../../../shared/components/Icon.vue';
import IconContainer from '../../../shared/components/IconContainer.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import AulaButton from '../../../shared/components/AulaButton.vue';

export default {
  components: {
    AulaButton,
    IconContainer,
    Icon,
    DocumentPreviewTableRow,
    TableHead,
    TableBody,
    TableRow,
    TableHeading,
    TableContainer,
  },
  props: {
    selectedDocuments: {
      type: Array as PropType<SecureDocumentModel[]>,
      default: () => [],
    },
    isChildSelectable: {
      type: Boolean,
      default: false,
    },
    childrenByDocument: {
      type: Map as PropType<Map<number, number[]>>,
      default: () => [],
    },
  },
  emits: ['remove', 'journalizedChildrenChanged'],
  data() {
    return {
      isCollapsed: false,
    };
  },
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
  },
  methods: {
    onRemove(documentId: number) {
      this.$emit('remove', documentId);
    },
    handleChildrenChanged(documentWithChildren: DocumentWithChildrenModel) {
      this.$emit('journalizedChildrenChanged', documentWithChildren);
    },
    handleAttachmentCollapsedState() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
